<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { NativeSelect } from '@shared/ui/fields'

import { useKidFields } from '../model/kid-fields.hook'

defineOptions({
  name: 'KidSelectVoip',
})

const {
  refVoip,
  voipOptions,
  setVoip,
} = useKidFields()
</script>

<template>
  <RowSlot label="VoIP:">
    <NativeSelect
      id="voip"
      name="voip"
      placeholder="Select voip"
      placeholder-enabled
      :value="refVoip"
      :options="voipOptions"
      @change="setVoip"
    />
  </RowSlot>
</template>
